module.exports = __webpack_public_path__ + "img/light_online_off.1eb00e65.png";